import React from "react";
import DatePicker from "react-datepicker";

// aria-labelledby / aria-label are passed through only when a caller sets
// them (react-datepicker forwards `ariaLabelledBy`), so existing uses are
// unchanged
const CustomInput = React.forwardRef(
  (
    {
      value,
      onClick,
      height,
      width,
      placeholder,
      "aria-labelledby": ariaLabelledBy,
      "aria-label": ariaLabel,
    },
    ref
  ) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      ref={ref}
      placeholder={placeholder}
      aria-labelledby={ariaLabelledBy}
      aria-label={ariaLabel}
      style={{ height, width }}
    />
  )
);

export const BasicDatePicker = ({
  onChange,
  value = null,
  height = "37px",
  width = "100%",
  placeholder = "Select Date",
  dateFormat = "dd/MM/yyyy",
  error,
  ...props
}) => {
  return (
    <>
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        timeIntervals={15}
        customInput={<CustomInput height={height} width={width} />}
        {...props}
      />
      {error && <span className="form__error">{error}</span>}
    </>
  );
};
